import { createContext } from 'react';
import { AgentContextData } from './interfaces/agent-context-props.interface';

const AgentContext = createContext<AgentContextData>({} as AgentContextData);

export default AgentContext;
